import { render, staticRenderFns } from "./Aggregates.vue?vue&type=template&id=6169cb2d"
import script from "./Aggregates.vue?vue&type=script&lang=js"
export * from "./Aggregates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports